import { Input } from "antd";
import React from "react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpDownIcon,
  FilterIcon,
  SearchIcon,
} from "../../../components/Icons";

const SearchAndFilter = ({ title, arrow, inputWidth = "small" }) => {
  return (
    <div className="searchAndFilter">
      <div className="sfLeft">
        <p>{title}</p>
      </div>
      <div className="sfRight">
        <Input
          style={{ width: inputWidth === "small" ? "252px" : "590px" }}
          prefix={<SearchIcon />}
          placeholder="Search"
        />
        <div className="sfIcon">
          <ArrowUpDownIcon />
        </div>
        <div className="sfIcon">
          <FilterIcon />
        </div>
        {arrow && (
          <div className="arrowBox">
            <div className="sfIcon">
              <ArrowLeftIcon />
            </div>
            <div className="sfIcon">
              <ArrowRightIcon />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilter;
